import { Injectable } from '@angular/core';
import { HttpClientService } from 'src/app/http-confing/http/http-client.service';

@Injectable({ providedIn: 'root' })
export class FacebookAdsReportService {
  constructor(private http: HttpClientService) {}

  getPages() {
    return this.http.get('page-ads/pages');
  }

  getCampaigns(platform: string, pageId: number, from: string, to: string) {
    return this.http.get('page-ads/report/campaigns', {
      platform,
      page_id: pageId,
      from,
      to,
    });
  }

  getAdAccounts(platform: string) {
    return this.http.get('page-ads/ad-accounts', { platform });
  }

  linkAdAccount(adAccountId: string, platform: string, pageId: number | null) {
    return this.http.put({ platform, page_id: pageId }, `page-ads/ad-accounts/${adAccountId}/link`);
  }
}
